import { render, staticRenderFns } from "./AccessibilityPanel.vue?vue&type=template&id=5d6a3236&scoped=true&"
import script from "./AccessibilityPanel.vue?vue&type=script&lang=js&"
export * from "./AccessibilityPanel.vue?vue&type=script&lang=js&"
import style0 from "./AccessibilityPanel.vue?vue&type=style&index=0&id=5d6a3236&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6a3236",
  null
  
)

export default component.exports